<div
  #sidebar
  class="relative flex h-full flex-col border-r border-brand-primary-lightest bg-white shadow-sm"
>
  @if (!isExpanded()) {
    <div
      class="flex items-center justify-center border-b border-brand-primary-lighter p-4"
    >
      <button
        (click)="toggleSidebar()"
        class="flex items-center justify-center rounded p-2 text-brand-primary-pure transition-colors duration-150 hover:bg-brand-primary-lightest hover:text-brand-primary-dark focus:outline-none"
        aria-label="Expandir menu"
      >
        <ng-icon size="20" name="lucidePanelLeftOpen" />
      </button>
    </div>
  }

  <nav
    class="relative flex-1 overflow-y-auto px-2 pb-4"
    [class.pt-6]="isExpanded()"
    [class.pt-4]="!isExpanded()"
  >
    @if (isExpanded()) {
      <button
        (click)="toggleSidebar()"
        class="absolute right-2 top-3 z-10 flex items-center justify-center rounded p-1.5 text-brand-primary-pure transition-colors duration-150 hover:bg-brand-primary-lightest hover:text-brand-primary-dark focus:outline-none"
        aria-label="Recolher menu"
      >
        <ng-icon size="20" name="lucidePanelRightOpen" />
      </button>

      <div class="space-y-4">
        @for (item of visibleMenuItems(); track item.key) {
          <div>
            <div
              class="flex items-center rounded border-b border-brand-primary-lighter px-3 py-2 text-xs font-semibold text-brand-primary-pure"
            >
              <span
                class="truncate"
                [class.line-through]="item.deprecated"
                [class.text-neutral-low-medium]="item.deprecated"
                >{{ item.text }}</span
              >
              @if (item.showNewBadge) {
                <span
                  class="ml-2 shrink-0 rounded-full bg-brand-primary-pure px-2 py-0.5 text-xs font-semibold text-neutral-hight-pure"
                  aria-label="Novo"
                >
                  Novo
                </span>
              }
            </div>

            <div class="mt-3 space-y-1">
              @for (subItem of item.subItems; track subItem.key) {
                <a
                  [routerLink]="subItem.route"
                  routerLinkActive="bg-brand-primary-lighter text-neutral-low-pure"
                  class="flex items-center gap-2 rounded p-2 text-sm text-neutral-low-dark transition-colors duration-150 hover:bg-brand-primary-lighter hover:text-neutral-low-pure"
                  [class.opacity-60]="subItem.deprecated"
                >
                  <ng-icon class="shrink-0" [name]="subItem.icon" size="20" />
                  <span
                    class="min-w-0 flex-1 truncate text-sm"
                    [class.line-through]="subItem.deprecated"
                    [class.text-neutral-low-medium]="subItem.deprecated"
                    >{{ subItem.text }}</span
                  >
                  @if (subItem.showNewBadge) {
                    <span
                      class="shrink-0 rounded-full bg-brand-primary-pure px-2 py-0.5 text-xs font-semibold text-neutral-hight-pure"
                      aria-label="Novo"
                    >
                      Novo
                    </span>
                  }
                </a>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="space-y-4">
        @for (item of visibleMenuItems(); track item.key) {
          <div class="border-b border-brand-primary-lighter pb-4">
            <div class="space-y-4">
              @for (subItem of item.subItems; track subItem.key) {
                <a
                  [routerLink]="subItem.route"
                  routerLinkActive="bg-brand-primary-lighter text-neutral-low-pure"
                  class="group relative mx-auto flex w-fit justify-center rounded p-2 text-neutral-low-dark transition-colors duration-150 hover:bg-brand-primary-lighter hover:text-neutral-low-pure"
                  [class.opacity-60]="subItem.deprecated"
                  (mouseenter)="
                    showTooltip(subItem.text, $event, subItem.deprecated)
                  "
                  (mouseleave)="hideTooltip()"
                >
                  <ng-icon [name]="subItem.icon" size="20" />
                  @if (subItem.showNewBadge) {
                    <span
                      class="absolute -right-0.5 -top-0.5 size-2 rounded-full bg-brand-primary-pure"
                      aria-hidden="true"
                    ></span>
                  }
                </a>
              }
            </div>
          </div>
        }
      </div>
    }
  </nav>

  <!-- Tooltip -->
  @if (tooltip().visible) {
    <div
      class="pointer-events-none fixed z-[110] whitespace-nowrap rounded bg-brand-primary-lighter px-4 py-2 text-sm text-neutral-low-pure shadow-lg"
      [style.left.px]="tooltip().x"
      [style.top.px]="tooltip().y"
      [@tooltipAnimation]
    >
      <span
        [class.line-through]="tooltip().deprecated"
        [class.text-neutral-low-medium]="tooltip().deprecated"
        >{{ tooltip().text }}</span
      >
    </div>
  }
</div>
